import React from "react";
import { api } from "../api/api";
import { Button } from "@mui/material";
import { enqueueSnackbar } from "notistack";
import { FileDownIcon } from "lucide-react";

const ExportToExcel = ({ loading, setLoading, api_url, file_name }) => {
  return (
    <Button
      variant="outlined"
      disabled={loading}
      style={{gap:4}}
      onClick={async () => {
        try {
          setLoading(true);
          const res = await api.get(
            `${api_url}export_to_xcl/?file_name=${file_name}`,
            { responseType: "blob" } // 👈 key switch
          );

          const blob = new Blob([res.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });

          const url = window.URL.createObjectURL(blob);

          const a = document.createElement("a");
          a.href = url;
          a.download = `${file_name}.xlsx`; // auto filename
          document.body.appendChild(a);
          a.click(); // 👈 auto-download happens here
          a.remove();

          window.URL.revokeObjectURL(url);
        } catch (err) {
          console.error(err);
          enqueueSnackbar("Excel export failed", {
            variant: "error",
          });
        } finally {
          setLoading(false);
        }
      }}
    >
    <FileDownIcon/>  {loading ? "Exporting...":"Export"}
    </Button>
  );
};

export default ExportToExcel;
